import styled from 'styled-components';

import { Button } from 'components/Common';

export const StyledButton = styled(Button)`
  max-width: 372px;
`;
